import 'whatwg-fetch';
import { getConfig } from './getConfig';
import { combine } from './url';
import { loadFromStorage, saveToStorage } from './storage';
import { cacheQueryInDev, cacheQueryInDevSave } from './queryCache';
import { ms_dispatch } from './msEvents';
import { GetServiceToken } from '../components/map/msMapLoginUtils';

let getApp = () => global.root?.app;
let getToastr = () => global.toastr || { error: () => {}, warning: () => {}, info: () => {}, success: () => {} };
let getFetch = () => global.fetch;

export const getProfile = () => {
  let profile = (getApp() || {}).profile || 'default';
  return profile;
};

function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}

export const getAbsUrl = (url, data = {}) => {
  return combine(getUrl(url), { skey: app.getToken(), profile: getProfile(), ...data })
}

function checkVersionChanged(ser, cli) {
  let serNum = null;
  let cliNum = null;
  try {
    serNum = parseInt(ser);
    cliNum = parseInt(cli);
    if (serNum != cliNum) {
      if (confirm('Application Version Updated and will be reloaded.')) {
        location.href = location.href;
      }
    }
  } catch (ex) {
  }
}

function csvJSON(csv) {
  const lines = csv.split('\n');
  const result = [];
  // NOTE: If your columns contain commas in their values, you'll need
  // to deal with those before doing the next step 
  // (you might convert them to &&& or something, then covert them back later)
  // jsfiddle showing the issue https://jsfiddle.net/
  const headers = lines[0].split(',');

  for (let i = 1; i < lines.length; i++) {
    const obj = {};
    const currentline = lines[i].split(',');

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }
    result.push(obj);
  }
  return result; //JSON
}

const sessionExpiredCodes = [-1003, -1005];
const sessionInvalidCodes = [-1000, -1001, -1002];

const handleHtml = (response) => {
  document.open();
  document.write(response);
  document.close();

  return response;
};

// this one made public only for tests, do not use directly
export async function _query(url, fetchOptions, options = { skipError: false, skipIndicator: false, skipLogging: false }) {
  const toastr = getToastr();
  const fetch = getFetch();
  if (root.app?.pageReloading) {
    console.log('--skip requests -- reloading--');
    return null;
  }

  let loadingDecreased = false;

  // cache functionality
  let data = cacheQueryInDev(url, fetchOptions.body);
  if (data) return Promise.resolve(data);

  let app = getApp();
  if (app && app.updateStore && !options.skipIndicator) app.updateStore({ isLoading: app.isLoading + 1 });
  if (app && app.updateStore) app.updateStore({ globalLoading: app.globalLoading + 1 });

  // how to avoid duplicate toastr properly? example - E2 and E6 show both when invalid column type
  let responseErrorSpecified = false;

  return fetch(url, fetchOptions)
    .then(res => {
      res.headers.forEach((h, a) => {
        if (a == '__build') {
          // checkVersionChanged(h, __build);
        }
      });

      if (app && app.updateStore && !options.skipIndicator) app.updateStore({ isLoading: app.isLoading - 1 });
      if (app && app.updateStore) app.updateStore({ globalLoading: app.globalLoading - 1 });
      loadingDecreased = true;
      const contentType = res.headers.get('content-type') ?? "";

      // for dashboard
      if (contentType.includes('text/csv')) {
        return res.text().then(text => {
          try {
            return Promise.all([Promise.resolve({ count: null, rc: 0, value: csvJSON(text) }), Promise.resolve(res.status)]);
          } catch (e) {}
          console.log('E01:', text);
          if (!options.skipLogging) root.app.statsAddError('serverError', { code: 'E01', error: text }, 'E01');
          throw new Error(text);
        });
      }

      // For Diagrams
      if (contentType.includes('text/xml')) {
        return Promise.all([res.text(), Promise.resolve(res.status)]);
      }
      // application/geo+json
      // application/json
      if (contentType?.match('application/.*json') != null) {
        // if json we continue
        return Promise.all([res.json(), Promise.resolve(res.status)]);
      }
      // otherwise we just show error
      // text result came, we return promise which fails
      // with content error
      return res.text().then(text => {
        try {
          // last chance to check may be it is still json
          let json = JSON.parse(text || '{}'); // empty string will be like empty object
          // wow it successfully parsed, that happens sometimes, that it comes as text content/type but actually a JSON
          return Promise.all([Promise.resolve(json), Promise.resolve(res.status)]);
        } catch (e) {}
        console.log('E02:', text);
        // on 502 error status we need to skpip error popup and display html from response
        if (text.includes('html') && res.status === 502) {
          handleHtml(text);
          options.skipError = true;
          options.skipLogging = true;
          throw new Error(text);
        }

        if (!options.skipLogging) root.app.statsAddError('serverError', { code: 'E02', error: text }, 'E02');
        throw new Error(text);
      });
    })
    .then(async ([data, status]) => {
      let { error, response_warning, response_success } = data || {};

      if (typeof (error) === 'object' && error?.message) {
        error = error.message;
      }

      // for error log
      const errLog = { url, query: fetchOptions };

      // we have to logon
      if ([...sessionExpiredCodes, ...sessionInvalidCodes].some(s => data?.rc == s || data[0]?.rc == s)) {
        console.log('E03:', data);
        const onAction = () => {
          app.session_logout();
        };
        ms_dispatch('modal_confirm_open', { message: 'Session has expired', title: ' ', onAction, confirmButtonText: 'Log In' });
        if (!options.skipLogging) root.app.statsAddError('serverError', data, 'E03', false, errLog);
        // if (app) app.setToken(null);
        return;
      }

      if (error) {
        if (!options.skipLogging) root.app.statsAddError('serverError', data, 'E05', false, errLog);

        // if skip error
        if (options.skipError) {
          console.log('E04:', data);
          return data;
        }

        // other errors
        if (status == 409 || status >= 500) {
          console.log('E05:', data);
          responseErrorSpecified = true;
          toastr.error(error, url);
        } else {
          console.log('E06:', error);
          responseErrorSpecified = true;
          toastr.warning(error);
        }
        throw new Error(error);
      }

      if (response_warning) {
        console.log('E07:', response_warning);
        toastr.warning(response_warning);
      }
      if (response_success) {
        toastr.success(response_success);
      }
      if (data.versionUpdateKey) {
        // detect version change, force to reload
        root.app.changeVersionKey(data.versionUpdateKey);
      }

      // cache
      cacheQueryInDevSave(url, fetchOptions.body, data);
      return data;
    })
    .catch(res => {
      if (app && !loadingDecreased && !options.skipIndicator) app.updateStore({ isLoading: app.isLoading - 1 });
      if (app && !loadingDecreased) app.updateStore({ globalLoading: app.globalLoading - 1 });

      // ignore errors from SysStats
      if (url.includes('SysStats')) {
        throw new Error(res);
      }

      // log
      if (!options.skipLogging && !responseErrorSpecified) {
        root.app.statsAddError('serverError', { res, url, query: fetchOptions, error: res?.message, code: 'E09' }, 'E09');
      }

      // hide errors when version updated
      if (JSON.stringify(res)?.includes('502 Bad Gateway') || String(res)?.indexOf('502 Bad Gateway') > -1) {
        console.log('E09:', res);
        throw new Error(res);
      }

      // show toastr or log errors
      if (!options.skipError && !responseErrorSpecified) {
        // if html in response
        if (res.message.includes('</font>')) {
          res.message = res.message.substring(res.message.lastIndexOf('</font>') + 7);
        }

        if (isJsonString(res.message) && (JSON.parse(res.message).error || JSON.parse(res.message).warning)) {
          const r = JSON.parse(res.message) || {};
          const msg = r.error || r.warning;
          console.log('E10:', msg);
          if (r.rc == -2) toastr.warning(msg);
          else if (r.rc == -1) toastr.error(msg);
          else toastr.error(res.message);
        }
        // sometimes when JSON cant be parsed, this message appears
        // our best bet is to let you know
        else if (res.message.toLowerCase().indexOf('unexpected') >= 0) {
          console.log('E11:', res, '|' + res + '|');
          toastr.error('JSON Parse: ', res.message);
        } else {
          // otherwise errors show 2 times, in try and catch
          const missingRights = res.message?.includes('right for security code');
          const missingCC = res.message?.includes('by closing conditions');
          console.log('E12:', res);
          if (!missingRights && !missingCC) {
            toastr.error(res.message, url);
          }
        }
      }
      throw res;
    });
}

export async function get(url, data, options = {}, headers = {}) {
  await _check_token(url, options?.skipToken);

  // return postOffline(url, data);
  const params = { ...data };

  let app = getApp();
  if (!options.skipProfile) params.profile = getProfile();
  // !! temporary, make it work with portal
  let skeyToken;
  if (app && !options.skipToken) skeyToken = app?.skey ?? app?.getToken();
  const { apiUrl } = getConfig();
  url = combineAbsUrl(apiUrl, url, params);
  return _query(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'Skey': skeyToken,
      ...headers,
    },
  }, options);
}

export function getUrl(url, data = {}, options = {}) {
  const params = { ...data };
  let app = getApp();
  if (!options.skipProfile) params.profile = getProfile();
  if (app && !options.skipToken) params.skey = app.getToken();
  const { apiUrl } = getConfig();
  url = combineAbsUrl(apiUrl, url, params);
  return url;
}

export async function post(url, data, options = {}) {
  // return postOffline(url, data);
  await _check_token(url, options?.skipToken);

  let queryString = { };
  let app = getApp();
  // !! temporary, make it work with portal
  let skeyToken;

  // in portal it called skey in desktop it is token
  if (!options.skipToken) skeyToken = app?.skey ?? app?.getToken();
  if (!options.skipProfile) queryString.profile = getProfile();

  // usually bad to do this kind of custom thing here
  // but right now hard to do this reliably locally
  // so let's do this here, usually it is not a good practice
  // query should know nothing about map or some other specific logic
  if (data && data._layer) delete data._layer;

  if (['DQ.php', 'AC.php', 'DU.php', 'DA.php', 'DD.php'].some(d => url.indexOf(d) >= 0)) {
    let data2 = data || {};
    if (!Array.isArray(data)) data2 = [data2];
    queryString = { _: data2.map(d => d.table).join('.'), ...queryString };
  }

  const { apiUrl } = getConfig();
  url = combineAbsUrl(apiUrl, url, queryString, options);

  return _query(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': options?.contentType || 'application/json; charset=utf-8',
      'Skey': skeyToken,
      'Client-Version': window.__version,
      'Client-URL': window.location.href,
    },
    body: data != null && typeof(data) == 'object' && !options.text ? JSON.stringify(data) : data, // do not delete .text check!! it breaks redmine attachments
  }, options);
}

export async function remove(url, data, options = {}) {
  await _check_token(url, options?.skipToken);

  let queryString = { };
  let app = getApp();
  let skeyToken;

  // in portal it called skey in desktop it is token
  if (!options.skipToken) skeyToken = app?.skey ?? app?.getToken();
  if (!options.skipProfile) queryString.profile = getProfile();

  const { apiUrl } = getConfig();
  url = combineAbsUrl(apiUrl, url, queryString, options);

  return _query(url, {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'Skey': skeyToken,
      'Client-Version': window.__version,
      'Client-URL': window.location.href,
    },
    body: data != null && typeof(data) == 'object' && !options.text ? JSON.stringify(data) : data, // do not delete .text check!! it breaks redmine attachments
  }, options);
}


export function combineAbsUrl(apiUrl, url, queryString, options) {
  // token
  let arcGisToken = GetServiceToken(url);
  if (arcGisToken) {
    queryString = queryString || {};
    queryString.token = arcGisToken;
  }

  // if absolute path
  if (url.match(/^https?:\/\//) && !(options?.skipProxy)) {
    // if host is different we will need to send through the proxy

    // check if host is different
    let isDifferentHost = false;
    // check if urls are correct, otherwise URL constructor will fail.
    // url must start with http
    let apiDomain;
    if (apiUrl && apiUrl.indexOf('http') == 0)
      apiDomain = new URL(apiUrl).host;
    else
      apiDomain = location.host;

    // if this is full url
    if (url.indexOf('http') == 0) {
      isDifferentHost = apiDomain != new URL(url).host;
    }
    return (isDifferentHost ? window.gisproxy2url() + '?' : '') + combine(url, queryString);
  }
  // if path (starts with /app and /api) we keep URL as it is.
  // if apiUrl specifies different domain we keep domain and protocol, otherwise we null
  // because full path is already sent
  if (url.indexOf("/app") === 0 || url.indexOf("/api") === 0) {
    if (apiUrl.match(/^https?:\/\//)) {
      var t = new URL(apiUrl);
      apiUrl = t.protocol + "//" + t.host;
    } else {
      apiUrl = "";
    }
  }

  return combine((apiUrl ?? '') + url, queryString);
}


function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


// --------------------------
// -- token logic -----------

async function _query_check_token(url, fetchOptions, options) {
  await _check_token(url, options?.skipToken);
  return _query(url, fetchOptions, options);
}

async function _wait_token(url) {
  // wait untill token is updated, up to 60 seconds
  const waitMax = 5 * 60;
  let waited = 0;
  for (let i = 0; i < waitMax; i += 1) {
    await sleep(200);
    const tokenReloading = loadFromStorage('tokenReloading_d');
    waited = i + 1;

    if (!tokenReloading) {
      break;
    }
  }
  return waited;
}

function getDisplayURL(url) {
  return url;
  let displayURL = url.split('/api/')[1];
  displayURL = displayURL.split('?')[0];
  return displayURL;
}

async function _check_token(url, skipToken) {
  // call this function before creating fetchOptions
  const displayURL = getDisplayURL(url);

  if (skipToken) {
    return;
  }
  const tokenReloading = loadFromStorage('tokenReloading_d');
  let waited = 0;
  if (tokenReloading) {
    waited = await _wait_token(displayURL);
  }

  const shouldRefresh = root.app.session_getMinutesToAction();

  if (shouldRefresh) {
    // for debugging
    const queue = loadFromStorage('tokenRequestsQueue_d') || '';
    saveToStorage('tokenRequestsQueue_d', queue + ', ' + url);

    const res = await root.app.session_refreshToken();
  }
}

